import adobeAnalytics from './adobe-analytics';

adobeAnalytics();
